import { GetProject } from '@/connection/projects/get-project';
import { serializeError, getPayloadMessage, SerializedError } from '@/store/utils/serialize-error';
import { ProjectStateReducerCreator } from '../types';
import { RootState } from '@/store/main';

const loadProjectReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (
      {
        uuid,
        returnStoreStateIfExists,
        /* do not remove doNotSetLoadingState from types, even though it's not used here, it's used during pending state */
      }: { uuid: string; returnStoreStateIfExists?: boolean; doNotSetLoadingState?: boolean },
      { rejectWithValue, getState }
    ) => {
      try {
        if (returnStoreStateIfExists) {
          const rootState = getState() as RootState;
          const proj = rootState.project?.workingProject;
          if (proj && proj.uuid === uuid) {
            return proj;
          }
        }
        const result = await GetProject(uuid);
        if (!result) {
          return rejectWithValue('Error loading project');
        }
        if ('error' in result) {
          console.error('loadProject error', result.error);
          return rejectWithValue(serializeError(result.error));
        }
        return result;
      } catch (e) {
        return rejectWithValue(serializeError(e));
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.workingProject = action.payload;
        }
        state.loadingWorkingProject = false;
      },
      pending: (state, action) => {
        if (!action.meta?.arg.doNotSetLoadingState) {
          state.loadingWorkingProject = true;
        }
      },
      rejected: (state, action) => {
        console.error(action.payload);
        const payload = action.payload as SerializedError | string | undefined;
        const status = typeof payload === 'object' ? payload?.status : undefined;
        if (status !== 403) {
          state.loadingWorkingProjectError =
            getPayloadMessage(payload) || action.error?.message || 'Error loading project';
        }
        state.loadingWorkingProject = false;
      },
    }
  );
};

export default loadProjectReducer;
